import { render, staticRenderFns } from "./GiftProductInfoForm.vue?vue&type=template&id=4eb0b55b&"
import script from "./GiftProductInfoForm.vue?vue&type=script&lang=js&"
export * from "./GiftProductInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb0b55b')) {
      api.createRecord('4eb0b55b', component.options)
    } else {
      api.reload('4eb0b55b', component.options)
    }
    module.hot.accept("./GiftProductInfoForm.vue?vue&type=template&id=4eb0b55b&", function () {
      api.rerender('4eb0b55b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/GiftProductInfoForm.vue"
export default component.exports